import { Box, Flex, Grid, IconButton } from "@chakra-ui/react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { useState } from "react";
import { yearOfQuestion } from "../foundationTypes";
import QuestionYearCard from "./QuestionYearCard";

/** Older years shown at once, beside the prominent card. */
const PAGE_SIZE = 2;

/**
 * One workstream's years: the newest prominent on the left, older ones paginated on the right.
 *
 * "Newest" is the highest year present in this workstream, not the current calendar year — a group whose most
 * recent year is 2024 should still lead with it rather than show nothing prominent.
 */
export default function SectionGrid({ questions, onOpen }) {
  const [page, setPage] = useState(0);

  const sorted = [...(questions || [])].sort((a, b) => yearOfQuestion(b) - yearOfQuestion(a));
  const current = sorted[0];
  const older = sorted.slice(1);
  const pageItems = older.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE);
  const hasNext = older.length > (page + 1) * PAGE_SIZE;
  const hasPrev = page > 0;

  return (
    <Flex align="center" gap={2}>
      <Grid templateColumns="repeat(2, 1fr)" templateRows="repeat(2, 1fr)" gap={4} flex={1} minW={0}>
        <Box gridRow="1 / 3" gridColumn="1">
          {current ? (
            <QuestionYearCard question={current} prominent onOpen={() => onOpen(current)} />
          ) : null}
        </Box>
        {pageItems.map((question) => (
          <Box key={question.id} gridColumn="2">
            <QuestionYearCard question={question} onOpen={() => onOpen(question)} />
          </Box>
        ))}
      </Grid>

      {/* Rendered only when there is somewhere to page to, so a workstream with one or two years has no
          controls rather than two inert arrows. */}
      {hasNext || hasPrev ? (
        <Flex direction="column" gap={1} flexShrink={0}>
          {hasPrev ? (
            <IconButton
              icon={<CaretLeft size={18} />}
              variant="ghost"
              size="sm"
              color="gray.400"
              _hover={{ color: "darkTeal" }}
              aria-label="Newer years"
              onClick={() => setPage(page - 1)}
            />
          ) : null}
          {hasNext ? (
            <IconButton
              icon={<CaretRight size={18} />}
              variant="ghost"
              size="sm"
              color="gray.400"
              _hover={{ color: "darkTeal" }}
              aria-label="Older years"
              onClick={() => setPage(page + 1)}
            />
          ) : null}
        </Flex>
      ) : null}
    </Flex>
  );
}
